import type { GridTuning } from "@/character/draft";
import { parseCharacterSpritesheet } from "@/character/spritesheet";
import { consumePetCreateCard, type HomeEconomy } from "@/home/economy";
import { newPetId } from "@/pet/firestore-storage";
import { defaultPetSkillBar, emptyPetAllocation, type PetDefinition, type PetPlayerState } from "@/pet/types";

export type AppendPetFromSheetResult =
  | { ok: true; state: PetPlayerState; economy: HomeEconomy; pet: PetDefinition }
  | { ok: false; reason: string };

export async function appendPetFromSpritesheet(
  state: PetPlayerState,
  economy: HomeEconomy,
  input: { name: string; sheetDataUrl: string; gridTuning: GridTuning },
): Promise<AppendPetFromSheetResult> {
  if (economy.petCreateCards < 1) {
    return { ok: false, reason: "ไม่มีบัตรสร้างสัตว์เลี้ยง" };
  }
  const trimmed = input.name.trim() || "สัตว์เลี้ยง";
  try {
    const parsed = await parseCharacterSpritesheet(input.sheetDataUrl, input.gridTuning);
    const nextEco = consumePetCreateCard(economy);
    if (!nextEco) {
      return { ok: false, reason: "ไม่มีบัตรสร้างสัตว์เลี้ยง" };
    }
    const pet: PetDefinition = {
      id: newPetId(),
      name: trimmed.slice(0, 48),
      createdAt: Date.now(),
      spritesheetDataUrl: parsed.spritesheetDataUrl,
      grid: parsed.grid,
      actions: parsed.actions,
      apCardsApplied: 0,
      sizeCardsApplied: 0,
      statAllocation: emptyPetAllocation(),
      skillBar: defaultPetSkillBar(),
    };
    return {
      ok: true,
      state: { ...state, pets: [...state.pets, pet] },
      economy: nextEco,
      pet,
    };
  } catch (e) {
    return {
      ok: false,
      reason: e instanceof Error ? e.message : "สร้างสัตว์เลี้ยงไม่สำเร็จ",
    };
  }
}
